import React, {Component} from 'react';
import AdminApi from '../../lib/admin/admin-api';

class SearchBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            results: [],
            value: '',
            open: false
        };

        this.container = null;
        this.time = null;
        this.handleClick = this.clickHandle.bind(this);
    }


    componentDidMount() {
        this.registerEvents();
    }


    searchCall() {

        if (this.state.value.length >= 1) {

            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                AdminApi.search(this.state.value).then(response => {

                    if (response !== false) {
                        this.setState({results: response.data, open: true});

                    }
                });

            }, 100);

        }
    }

    clickHandle(e) {


        if(this.container && !this.container.contains(e.target)) {
            this.setState({ open : false});
        }
    }

    registerEvents() {
        window.addEventListener('click', this.handleClick);
    }

    handleChange(e) {

        if (e.target.value.length === 0) {
            return this.setState({results: [], open: false});
        }

        this.setState({value: e.target.value}, () => {
            this.searchCall();
        });
    }

    onClick() {
        this.searchCall();
    }

    getLink(item) {
        switch (item.type) {
            case('company') : {
                return `/companies/${item.type_id}`
            }
            case('user') : {
                return `/users/${item.type_id}`
            }
            default :
                return null;
        }
    }


    render() {

        const {results, value} = this.state;

        return (
            <div className="search-bar__outer"  ref={r => this.container = r}>
                <div className="search-bar__inner">
                    <img src="/assets/logos/search.svg" />
                    <input className={"search-bar " + (results.length > 0 ? "search-bar--toggled" : "")}
                       placeholder="Type here to start searching" onClick={this.onClick.bind(this)}
                       onChange={e => this.handleChange(e)}/>
                </div>
                
                {
                    (this.state.open === true) &&
                    <div className="search-bar__results">
                        <div className="search-bar__results">
                            <div className="search-bar__results-head">
                                <p>{results.length} results found</p>
                                {/* <div class="results-head__refine">
                                        Refine Search <img src="/assets/rightArrow.svg"/>
                                    </div> */}
                            </div>
                            <div className="search-bar__results-body">
                                {
                                    results.map((result, index) => {
                                        return (
                                            <div key={index} className="search-result" onClick={() => {
                                               const link = this.getLink(result);
                                               if(link) {
                                                   window.location = link;
                                               }

                                            }}><p>{result.title}</p><b>{result.type}</b></div>
                                        );
                                    })

                                }
                            </div>
                            {
                                results.length >= 5 &&
                                <div className="search-bar__results-bottom"
                                     onClick={() => window.location.href = "/search-results?term=" + value}>
                                    View all {results.length} results
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }

}

export default SearchBar;
